import { h } from './index-f214f983.js';
import { d as SearchSlimIcon } from './search-suggestion-36cc700b.js';
import { B as Button } from './button-b64416c8.js';

const TextAreaSubmitButton = ({ bindings, onClick, ...defaultButtonProps }) => (h("div", { part: "submit-button-wrapper", class: "mr-2 flex items-start items-center justify-center py-2" },
    h(Button, { style: "text-primary", class: "flex h-8 w-8 shrink-0 items-center justify-center rounded-full", part: "submit-button", ariaLabel: bindings.i18n.t('search'), onClick: () => {
            onClick === null || onClick === void 0 ? void 0 : onClick();
        }, ...defaultButtonProps },
        h("atomic-icon", { part: "submit-icon", icon: SearchSlimIcon, class: "h-4 w-4" }))));

export { TextAreaSubmitButton as T };

//# sourceMappingURL=text-area-submit-button-46a94faa.js.map